// TableRowData.js
import React, { useState } from 'react';
import {
  Box,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@mui/material';
import { H5, H6, Paragraph } from 'app/components/Typography';
import { Avatar } from '@mui/material';
import styled from '@emotion/styled';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const ProductTable = styled(Table)(() => ({
  minWidth: 400,
  whiteSpace: 'pre',
  '& small': {
    width: 50,
    height: 15,
    borderRadius: 500,
    boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.24)'
  },
  '& td': { borderBottom: 'none' },
  '& td:first-of-type': { paddingLeft: '16px !important' }
}));
function SellTableRowData(props) {
  const { row } = props;
  const [open, setOpen] = useState(false);

  const convertDate = (isoDateString) => {
    const date = new Date(isoDateString);

    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    };
    const formattedDate = date.toLocaleString('en-GB', options).replace(/\//g, '-');
    return formattedDate;
  };

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }} onClick={() => setOpen(!open)} hover>
        <TableCell align='center' sx={{ textTransform: 'capitalize' }}>
          <H5 sx={{ m: 0 }}>{row.id}</H5>
        </TableCell>
        <TableCell align='center' sx={{ textTransform: 'capitalize' }}>
          {row.book_number}
        </TableCell>
        <TableCell align='center' sx={{ textTransform: 'capitalize' }}>
          {convertDate(row.date)}
        </TableCell>
        <TableCell align='left' sx={{ textTransform: 'capitalize' }}>
          {row.customer_name}
        </TableCell>
        <TableCell align='center' sx={{ textTransform: 'capitalize' }}>
          {row.self_pieces ? row.self_pieces : 0}
        </TableCell>
        <TableCell align='center' sx={{ textTransform: 'capitalize' }}>
          {row.cust_pieces ? row.cust_pieces : 0}
        </TableCell>
        <TableCell align='center' sx={{ textTransform: 'capitalize' }}>
          {row.studd_pieces ? row.studd_pieces : 0}
        </TableCell>
        <TableCell align='center' sx={{ textTransform: 'capitalize' }}>
          {row.labour_charge_per_pcs}
        </TableCell>
        <TableCell align='center' sx={{ textTransform: 'capitalize' }}>
          {row.labour_charge}
        </TableCell>
        <TableCell align='center' sx={{ textTransform: 'capitalize' }}>
          {row.self_weight}
        </TableCell>
        <TableCell align='center' sx={{ textTransform: 'capitalize' }}>
          {row.studd_weight}
        </TableCell>
        <TableCell align='center' sx={{ textTransform: 'capitalize' }}>
          {row.product_price}
        </TableCell>
        <TableCell align='center' sx={{ textTransform: 'capitalize' }}>
          {row.extra_cost}
        </TableCell>
        <TableCell align='center' sx={{ textTransform: 'capitalize' }}>
          {row.quantity}
        </TableCell>
        <TableCell align='center' sx={{ textTransform: 'capitalize' }}>
          {row.total}
        </TableCell>
        <TableCell align='center'>
          <IconButton aria-label='expand row' size='small'>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={16}>
          <Collapse in={open} timeout='auto' unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <ProductTable>
                <TableHead sx={{ backgroundColor: 'rgb(34,41,67)' }}>
                  <TableRow>
                    <TableCell align='center' sx={{ fontWeight: 'bold', color: '#FFFFFF' }}>
                      Order-Id
                    </TableCell>
                    <TableCell align='center' sx={{ fontWeight: 'bold', color: '#FFFFFF' }}>
                      Item-Name
                    </TableCell>
                    <TableCell align='left' sx={{ fontWeight: 'bold', color: '#FFFFFF' }}>
                      Product-Name
                    </TableCell>
                    <TableCell align='center' sx={{ fontWeight: 'bold', color: '#FFFFFF' }}>
                      Inward Type
                    </TableCell>
                    <TableCell align='center' sx={{ fontWeight: 'bold', color: '#FFFFFF' }}>
                      Date
                    </TableCell>
                    <TableCell align='center' sx={{ fontWeight: 'bold', color: '#FFFFFF' }}>
                      Self-Pcs
                    </TableCell>
                    <TableCell align='center' sx={{ fontWeight: 'bold', color: '#FFFFFF' }}>
                      Cust-Pcs
                    </TableCell>
                    <TableCell align='center' sx={{ fontWeight: 'bold', color: '#FFFFFF' }}>
                      Total-Pcs
                    </TableCell>
                    <TableCell align='center' sx={{ fontWeight: 'bold', color: '#FFFFFF' }}>
                      Self-Wt
                    </TableCell>
                    <TableCell align='center' sx={{ fontWeight: 'bold', color: '#FFFFFF' }}>
                      Cus-Wt
                    </TableCell>
                    <TableCell align='center' sx={{ fontWeight: 'bold', color: '#FFFFFF' }}>
                      Total-Wt
                    </TableCell>
                    <TableCell align='center' sx={{ fontWeight: 'bold', color: '#FFFFFF' }}>
                      Labour
                    </TableCell>
                    <TableCell align='center' sx={{ fontWeight: 'bold', color: '#FFFFFF' }}>
                      Diamond
                    </TableCell>
                    <TableCell align='center' sx={{ fontWeight: 'bold', color: '#FFFFFF' }}>
                      Product
                    </TableCell>
                    <TableCell align='center' sx={{ fontWeight: 'bold', color: '#FFFFFF' }}>
                      Extra Amt
                    </TableCell>
                    <TableCell align='center' sx={{ fontWeight: 'bold', color: '#FFFFFF' }}>
                      Total Amt
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {row.orders && row.orders.length > 0 ? (
                    row.orders.map((orderDetails, index) => (
                      <TableRow key={index} hover>
                        <TableCell align='center' sx={{ textTransform: 'capitalize' }}>
                          <H6 sx={{ m: 0 }}>{orderDetails.id}</H6>
                        </TableCell>

                        <TableCell align='center' sx={{ textTransform: 'capitalize' }}>
                          {orderDetails.item_name}
                        </TableCell>
                        <TableCell align='left' sx={{ textTransform: 'capitalize' }}>
                          <Box display='flex' alignItems='center'>
                            <Avatar src={orderDetails.productimage} />
                            <Paragraph sx={{ m: 0, ml: 1 }}>{orderDetails.product_name}</Paragraph>
                          </Box>
                        </TableCell>
                        <TableCell align='center'>{orderDetails.order_inward_type}</TableCell>
                        <TableCell align='center'>{convertDate(orderDetails.date)}</TableCell>
                        <TableCell align='center'>
                          {orderDetails.studdSelfPiece ? orderDetails.studdSelfPiece : 0}
                        </TableCell>
                        <TableCell align='center'>
                          {orderDetails.studdCustPiece ? orderDetails.studdCustPiece : 0}
                        </TableCell>
                        <TableCell align='center'>
                          {orderDetails.studdPiece ? orderDetails.studdPiece : 0}
                        </TableCell>
                        <TableCell align='center'>
                          {orderDetails.studdSelfWeight ? orderDetails.studdSelfWeight : 0}
                        </TableCell>
                        <TableCell align='center'>
                          {orderDetails.studdWeight ? orderDetails.studdWeight : 0}
                        </TableCell>
                        <TableCell align='center'>
                          {parseFloat(
                            parseFloat(
                              (orderDetails.studdWeight
                                ? parseFloat(parseFloat(orderDetails.studdWeight).toFixed(3))
                                : 0) +
                                (orderDetails.studdSelfWeight
                                  ? parseFloat(parseFloat(orderDetails.studdSelfWeight).toFixed(3))
                                  : 0)
                            ).toFixed(3)
                          )}
                        </TableCell>
                        <TableCell align='center'>
                          {orderDetails.labourCharge ? orderDetails.labourCharge : 0}
                        </TableCell>
                        <TableCell align='center'>
                          {orderDetails.diamondPrice ? orderDetails.diamondPrice : 0}
                        </TableCell>
                        <TableCell align='center'>
                          {orderDetails.product_price ? orderDetails.product_price : 0}
                        </TableCell>
                        <TableCell align='center'>
                          {orderDetails.extra_cost ? orderDetails.extra_cost : 0}
                        </TableCell>

                        <TableCell align='center' sx={{ fontWeight: 'bold' }}>
                          {orderDetails.totalAmount ? orderDetails.totalAmount : 0}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={16}
                        align='center'
                        sx={{ color: 'rgb(34,41,67)', fontWeight: 'bold' }}
                      >
                        No Order Details Found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </ProductTable>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default SellTableRowData;
